import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  Divider,
  Stack
} from '@mui/material';
import {
  Block as BlockIcon,
  Payment as PaymentIcon,
  WhatsApp as WhatsAppIcon,
  Email as EmailIcon
} from '@mui/icons-material';
import { usePayment } from '../../contexts/PaymentContext';

/**
 * Tela de bloqueio total quando o pagamento esta muito atrasado (15+ dias)
 * Sobrepoe todo o sistema e so permite pagar ou entrar em contato
 */
const PaymentBlockedScreen = () => {
  const { statusData, openPaymentModal, isBlocked, loading } = usePayment();

  // Nao exibir se nao estiver bloqueado ou ainda carregando
  if (loading || !isBlocked()) {
    return null;
  }

  const diasAtraso = statusData?.diasAtraso || 0;
  const valorPendente = statusData?.faturaValor || statusData?.planoValor || 0;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2
      }}
    >
      <Container maxWidth="sm">
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            overflow: 'hidden'
          }}
        >
          {/* Header vermelho */}
          <Box
            sx={{
              backgroundColor: '#d32f2f',
              color: 'white',
              p: 3,
              textAlign: 'center'
            }}
          >
            <BlockIcon sx={{ fontSize: 64, mb: 2 }} />
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Acesso Bloqueado
            </Typography>
            <Typography variant="body1">
              Identificamos um problema com seu pagamento
            </Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            {/* Informacoes do atraso */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Typography variant="h6" color="text.secondary" gutterBottom>
                Sua mensalidade esta em atraso ha
              </Typography>
              <Typography
                variant="h2"
                fontWeight="bold"
                color="error"
                sx={{ my: 2 }}
              >
                {diasAtraso} dias
              </Typography>
              {valorPendente > 0 && (
                <Typography variant="body1" color="text.secondary">
                  Valor pendente: <strong>R$ {valorPendente.toFixed(2).replace('.', ',')}</strong>
                </Typography>
              )}
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Mensagem */}
            <Typography variant="body1" textAlign="center" sx={{ mb: 4 }}>
              Para voltar a utilizar o sistema, regularize sua situacao
              efetuando o pagamento ou entrando em contato conosco.
            </Typography>

            {/* Botoes de acao */}
            <Stack spacing={2}>
              <Button
                variant="contained"
                size="large"
                fullWidth
                startIcon={<PaymentIcon />}
                onClick={() => openPaymentModal()}
                sx={{
                  py: 1.5,
                  fontSize: '1.1rem',
                  backgroundColor: '#2e7d32',
                  '&:hover': {
                    backgroundColor: '#1b5e20'
                  }
                }}
              >
                Pagar Agora
              </Button>

              <Button
                variant="outlined"
                size="large"
                fullWidth
                startIcon={<WhatsAppIcon />}
                href="https://wa.me/5500000000000"
                target="_blank"
                sx={{
                  py: 1.5,
                  borderColor: '#25d366',
                  color: '#25d366',
                  '&:hover': {
                    borderColor: '#128c7e',
                    backgroundColor: 'rgba(37, 211, 102, 0.1)'
                  }
                }}
              >
                Falar no WhatsApp
              </Button>

              <Button
                variant="text"
                size="small"
                startIcon={<EmailIcon />}
                href="mailto:suporte@phada.com.br"
                sx={{ color: 'text.secondary' }}
              >
                suporte@phada.com.br
              </Button>
            </Stack>

            {/* Rodape */}
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              textAlign="center"
              sx={{ mt: 4 }}
            >
              Apos o pagamento, o acesso sera liberado automaticamente em ate 5 minutos.
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default PaymentBlockedScreen;
